import { render } from "./FooterListKulioner.vue?vue&type=template&id=13d0944f&ts=true"
import script from "./FooterListKulioner.vue?vue&type=script&lang=ts"
export * from "./FooterListKulioner.vue?vue&type=script&lang=ts"

import "./FooterListKulioner.vue?vue&type=style&index=0&id=13d0944f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__